import React, { useState } from 'react';
import { Select, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import map from 'lodash/map';
import filter from 'lodash/filter';
import { createManagers } from './../reducer/actions';
import { ReactComponent as Delete } from '../../../images/trash_gray.svg';
import { each } from 'lodash';
const { Option } = Select;

const Wrapper = styled.div`
  &&& {
    background: white;
    padding: 3px 20px;
    border-radius: 6px;
    margin: 5px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-select-selector {
      border-radius: 6px !important;
    }
    .delete {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

function AddManager({
  storageId,
  data,
  addManager,
  setAddManager,
  managers,
  getUsers,
  loadingUsers,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [userId, setId] = useState(null);
  const handleCreate = () => {
    dispatch(createManagers(userId, Number(id), getUsers));
  };
  const handleChange = (value) => {
    setId(value);
  };
  return (
    <Wrapper>
      <div className="flex items-center">
        <Select
          onChange={handleChange}
          showSearch
          style={{ width: 214 }}
          suffixIcon={<span></span>}
          placeholder="Выберете адинистратора"
          // optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {data
            ? data.length !== 0
              ? map(
                  filter(
                    data,
                    (ar) => !managers.find((rm) => rm.user.id === ar.id),
                  ),
                  (item) => {
                    return (
                      <Option value={item.id}>
                        {item.first_name} {item.last_name}
                      </Option>
                    );
                  },
                )
              : null
            : null}
        </Select>
        <Button
          onClick={() => {
            handleCreate();
          }}
          type="primary"
          className="pl-18"
          type="link"
          loading={loadingUsers}
        >
          <span style={{ borderBottom: '1px dotted #4b97e9' }}>
            {t('connectToSlad')}
          </span>
        </Button>
      </div>

      <Delete
        className="cursor-pointer"
        onClick={() => {
          setAddManager(!addManager);
        }}
      />
    </Wrapper>
  );
}

AddManager.propTypes = {};

export default AddManager;
